import "./styles.scss";

import ModalBox from "components/Modal";
import type { INewStatementForm } from "components/PartnerStatementsSettings/types";
import ScrollShadowWrapper from "components/shared/ScrollShadowWrapper";
import StyledButton from "components/shared/StyledButton";
import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import type { IIntegrations } from "store/integrationsStore";
import {
    fetchGoogleSpreadSheets,
    setCollapsedSpreadsheet,
    setGoogleSpreadsheets,
    setSelectedSheet,
} from "store/partnerStatementsStore";
import { useAppDispatch, useAppSelector } from "store/store";

import SearchSheetBlock from "../SearchSheetBlock";

interface ISearchSheetModal {
    open: boolean;
    onClose: () => void;
    currentIntegration: IIntegrations;
    /**
     * Action on validate the new chosen template, it fetch google spreadsheet data
     */
    onValidateNewTemplate: () => void;
    mode: "new" | "edit";
}

/**
 * On edit a custom statement, this modal give the possibility to chose another Google template
 */
const SearchSheetModal = ({ open, onClose, currentIntegration, onValidateNewTemplate, mode }: ISearchSheetModal) => {
    const { selectedSheet } = useAppSelector((state) => state.partnerStatements);
    const { setValue } = useFormContext<INewStatementForm>();
    const dispatch = useAppDispatch();
    const [t] = useTranslation();
    const hasSelectedSheet = selectedSheet.id != null;

    useEffect(() => {
        if (open) {
            dispatch(fetchGoogleSpreadSheets(currentIntegration?.id));
        }
        dispatch(setCollapsedSpreadsheet({ id: "", name: "" }));
        dispatch(setSelectedSheet({ id: null, name: "" }));
        dispatch(setGoogleSpreadsheets([]));
    }, [dispatch, open]);

    const onSubmitNewTemplate = () => {
        onValidateNewTemplate();
        onClose();
        setValue("iterationRange", "", { shouldDirty: true });
    };

    return (
        <ModalBox
            open={open}
            onClose={onClose}
            mainTitle={t("PartnerStatements.SearchGoogleSheetsTemplate")}
            style={{ width: "700px" }}
        >
            <div className="search-sheet-modal">
                <ScrollShadowWrapper style={{ maxHeight: "400px" }}>
                    <SearchSheetBlock currentIntegration={currentIntegration} mode={mode} />
                </ScrollShadowWrapper>
                <div className="search-sheet-modal-btn">
                    <StyledButton buttonType="secondary" onClick={onClose}>
                        {t("PartnerStatements.Cancel")}
                    </StyledButton>
                    <StyledButton buttonType="primary" disabled={!hasSelectedSheet} onClick={onSubmitNewTemplate}>
                        {t("PartnerStatements.ValidateTemplate")}
                    </StyledButton>
                </div>
            </div>
        </ModalBox>
    );
};

export default SearchSheetModal;
